export const updateEntitySystemMutation = () => {
    return `
    mutation UpdateEntitySystem(
        $entitySystemId: Int!,
        $entityId: Int,
        $systemId: Int,
        $integrationType: String,
        $isRequiredDaily: Boolean,
        $isGenerateIpe: Boolean,
        $forceGenerate: JSONString
    ) {
        updateEntitySystem(
            entitySystemId: $entitySystemId,
            entityId: $entityId,
            systemId: $systemId,
            integrationType: $integrationType,
            isRequiredDaily: $isRequiredDaily,
            isGenerateIpe: $isGenerateIpe,
            forceGenerate: $forceGenerate
        ) {
            entitySystem {
                id
                entity {
                    id
                    name
                }
                system {
                    id
                    name
                }
                integrationType
                isRequiredDaily
                isGenerateIpe
                forceGenerate
                createdAt
                updatedAt
            }
        }
    }
    `
}
